 const LinkBridge = (props) => {
   const divClass = props.current + "_bridge";
   return (
     <div id="selected_link_bridge" className={divClass}></div>
   );
 };

export default LinkBridge;
